import { useQuery } from '@tanstack/react-query';
import { ExternalIcons, searchAPI } from 'api/search';
import React from 'react';
import IconMi from 'components/common/icon/IconMi';
import { Box } from '@mui/material';

const simpleIcons = ['elements', 'datasets', 'burst', 'all-items', 'charting-options'];

export default function DatabaseIcon({
    name,
    type,
    placeholderIconName,
}: {
    name: string;
    type?: string;
    placeholderIconName?: string;
}) {
    // The lookup is a hook, so it runs on every render whatever the props say: a chip is mounted
    // with no name and gains one when its tile arrives. The query key is constant.
    const { data: externalIcons } = useQuery<ExternalIcons, Error>({
        queryKey: ['fetchGlobalSearchIcons'],
        queryFn: () => searchAPI.getExternalIcons(),
    });

    const iconWrapper = (children: any) => {
        return (
            <Box
                sx={{
                    width: '16px',
                    height: '16px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    img: { maxWidth: '100%', maxHeight: '100%' },
                }}
            >
                {children}
            </Box>
        );
    };

    // A caller that names a placeholder is asking never to draw nothing, so an element with no
    // content type of its own still gets a glyph.
    if (name === '') {
        return placeholderIconName
            ? iconWrapper(<IconMi icon={placeholderIconName} sx={{ fontSize: '16px' }} />)
            : null;
    }

    if (simpleIcons.includes(name)) {
        return iconWrapper(<IconMi icon={name} sx={{ fontSize: '16px' }} />);
    }

    if (externalIcons && externalIcons[name]) {
        return iconWrapper(<Box component={'img'} src={externalIcons[name]} />);
    }

    if (externalIcons && type === 'external_content') {
        return iconWrapper(<Box component={'img'} src={externalIcons['Default']} />);
    }

    if (type == 'dataset_data') {
        return iconWrapper(<Box component={'img'} src={`data:image/png;base64,${name}`} />);
    }

    if (placeholderIconName) {
        return iconWrapper(<IconMi icon={placeholderIconName} sx={{ fontSize: '16px' }} />);
    }

    return null;
}
